<template>
  <el-dialog
    class="upgrade-title"
    title="系统公告"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="50%"
    :before-close="handleClose">
      <div v-html="htmlData" class="html-data"></div>
    <span slot="footer" class="dialog-footer">
      <el-checkbox-group v-model="checkValue" @change="changeValue" class="check-box" v-if="!allowField.includes('notice')">
        <el-checkbox v-model="checked">不再弹出</el-checkbox>
      </el-checkbox-group>
      <el-button type="primary" @click="know" size="medium" v-if="!allowField.includes('notice')">关闭</el-button>
      <el-button type="primary" @click="know" size="medium" v-if="allowField.includes('notice')">知道了</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'NoticeDialog',
  props: {
    dialogVisible: {
      default: false,
      type: Boolean
    },
    htmlData: {
      default: ''
    },
    isShowCheck: {
      default: true,
      type: Boolean
    },
    allowField: {
      default: () => [],
      required: false
    }
  },
  data() {
    return {
      checked: false,//是否选中
      checkValue: false
    }
  },
  methods: {
    know() {
      this.$emit('know', this.checkValue)
    },
    handleClose() {
      this.$emit('handleClose', this.checkValue)
    },
    changeValue() {
      console.log(this.checkValue, "this.checkValue")
    }
  }
}
</script>
<style scoped lang="stylus">
  .check-box
    padding: 10px 0
    position: absolute
    right: 90px
  /deep/.check-box .el-checkbox__label
    font-size: 12px
  .html-data
    padding: 5px 0
    font-size: 15px
</style>